export default {
	currentUser: {
		uid: null,
		email: null,
		displayName: null,
		photoUrl: null,
	},
	isLoggedIn: false,
	hasAccess: false,
	isVerified: false,
	isSuper: false,
	lastLogin: null,
	transporterCode: localStorage.getItem('transporterCode') || null,
	usersWithAccess: [],
	superUsers: [],
	companies: [],
};
